"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Journal_exports = {};
__export(Journal_exports, {
  default: () => Journal_default
});
module.exports = __toCommonJS(Journal_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.67188 6.08984C6.67188 5.94661 6.71745 5.82943 6.80859 5.73828C6.91276 5.63411 7.02995 5.58203 7.16016 5.58203H8.83984C8.97005 5.58203 9.08073 5.63411 9.17188 5.73828C9.27604 5.82943 9.32812 5.94661 9.32812 6.08984C9.32812 6.22005 9.27604 6.33724 9.17188 6.44141C9.08073 6.53255 8.97005 6.57812 8.83984 6.57812H7.16016C7.02995 6.57812 6.91276 6.53255 6.80859 6.44141C6.71745 6.33724 6.67188 6.22005 6.67188 6.08984ZM7.16016 8.08203C7.02995 8.08203 6.91276 8.13411 6.80859 8.23828C6.71745 8.32943 6.67188 8.44661 6.67188 8.58984C6.67188 8.72005 6.71745 8.83724 6.80859 8.94141C6.91276 9.03255 7.02995 9.07812 7.16016 9.07812H12.1602C12.3034 9.07812 12.4206 9.03255 12.5117 8.94141C12.6159 8.83724 12.668 8.72005 12.668 8.58984C12.668 8.44661 12.6159 8.32943 12.5117 8.23828C12.4206 8.13411 12.3034 8.08203 12.1602 8.08203H7.16016ZM6.67188 11.0898C6.67188 10.9466 6.71745 10.8294 6.80859 10.7383C6.91276 10.6341 7.02995 10.582 7.16016 10.582H11.3398C11.4701 10.582 11.5807 10.6341 11.6719 10.7383C11.776 10.8294 11.8281 10.9466 11.8281 11.0898C11.8281 11.2201 11.776 11.3372 11.6719 11.4414C11.5807 11.5326 11.4701 11.5781 11.3398 11.5781H7.16016C7.02995 11.5781 6.91276 11.5326 6.80859 11.4414C6.71745 11.3372 6.67188 11.2201 6.67188 11.0898ZM7.16016 13.082C7.02995 13.082 6.91276 13.1341 6.80859 13.2383C6.71745 13.3294 6.67188 13.4466 6.67188 13.5898C6.67188 13.7201 6.71745 13.8372 6.80859 13.9414C6.91276 14.0326 7.02995 14.0781 7.16016 14.0781H13C13.1432 14.0781 13.2604 14.0326 13.3516 13.9414C13.4557 13.8372 13.5078 13.7201 13.5078 13.5898C13.5078 13.4466 13.4557 13.3294 13.3516 13.2383C13.2604 13.1341 13.1432 13.082 13 13.082H7.16016ZM3.83984 3.58984V15.25C3.83984 16.1745 4.16536 16.9622 4.81641 17.6133C5.46745 18.2643 6.2487 18.5898 7.16016 18.5898H17.1602C17.6289 18.5898 18.026 18.4271 18.3516 18.1016C18.6771 17.776 18.8398 17.3789 18.8398 16.9102V11.9102C18.8398 11.4544 18.6771 11.0638 18.3516 10.7383C18.026 10.4128 17.6289 10.25 17.1602 10.25H16.3398V3.58984C16.3398 3.12109 16.1771 2.72396 15.8516 2.39844C15.526 2.07292 15.1289 1.91016 14.6602 1.91016H5.5C5.04427 1.91016 4.65365 2.07292 4.32812 2.39844C4.0026 2.72396 3.83984 3.12109 3.83984 3.58984ZM15.3242 3.58984V17.5742H7.16016C6.52214 17.5742 5.97526 17.3464 5.51953 16.8906C5.0638 16.4349 4.83594 15.888 4.83594 15.25V3.58984C4.83594 3.40755 4.90104 3.2513 5.03125 3.12109C5.16146 2.99089 5.31771 2.92578 5.5 2.92578H14.6602C14.8424 2.92578 14.9987 2.99089 15.1289 3.12109C15.2591 3.2513 15.3242 3.40755 15.3242 3.58984ZM16.3398 16.7539V11.2461H17.1602C17.3424 11.2461 17.4987 11.3112 17.6289 11.4414C17.7591 11.5716 17.8242 11.7279 17.8242 11.9102V16.9102C17.8242 17.0924 17.7591 17.2487 17.6289 17.3789C17.4987 17.5091 17.3424 17.5742 17.1602 17.5742C16.9388 17.5742 16.7435 17.4961 16.5742 17.3398C16.418 17.1706 16.3398 16.9753 16.3398 16.7539Z",
      fill: "currentColor"
    }
  )
);
const SvgJournal = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Journal_default = SvgJournal;
